import { Component, input } from '@angular/core';
import { TextNodeType } from '@mwe/models';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-basic-card-title',
  templateUrl: './basic-card-title.component.html',
  imports: [TranslatePipe],
})
export class BasicCardTitleComponent {
  iconClass = input<string>();
  cardTitle = input<string>();
  cardTitleParams = input();
  headingNodeType = input<TextNodeType>('h5');
}
